import React, { useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "../ag-table.css";
import CurrentMonthRowData from "./currentMonthRowData";
import { currentMonthColDef } from "./currentMonthColDef";
import ModalComponent from "../ModalComponent";
import { useModalContext } from "../ModalContext";
import {
  currencyFormat,
  getCurrentMonthDatesAsia,
  getDatesFromMonthYearAsia,
} from "../helpers";
import { roundData } from "../helpers/currentMonthSummaryData";
import { Alert, Box, Button, Snackbar } from "@mui/material";
import BasicSelect from "../components/BasicSelect";
import { TYPES } from "../constants";
import LoadingSpinner from "../components/LoadingSpinner";
import AddNewProductModal from "../components/AddNewProductModal";
import { fetchEditPermissions } from "../api/editpermissions";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import EditModal from "../current-month-summary/EditModal";
import { formatUpdatedCurrentMonthData } from "../helpers/currentMonthData";
import AlertModal from "../components/AlertModal";
import AddNewScheme from "../components/AddNewScheme";
import api from "../axiosConfig";

const CurrentMonth = ({ open }) => {
  const { currency } = useModalContext();
  const [type, setType] = useState(TYPES[0]);
  const [currencyType, setCurrencyType] = useState(currency);
  const [isGroup,setIsGroup]=useState(false)
  // calling params
  const location = useLocation();
  const navigate = useNavigate();
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    setCurrencyType(currency);
  }, [currency]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encodedFilters = params.get("encodedFilters"); // Match the key in the URL

    if (encodedFilters) {
      try {
        const decodedFilters = atob(encodedFilters); // Decode Base64
        setFilter(decodedFilters);
      } catch (error) {
        console.error("Error decoding filters", error);
      }
    }
  }, [location.search]);

  // console.log(filter, "filterdata");

  const searchParams = new URLSearchParams(filter);
  // const searchParams = new URLSearchParams(location.search);
  // console.log(location.search, "location.search");
  const rawWarehouse = searchParams.get("Warehouse");
  const warehouse =
    !rawWarehouse || rawWarehouse.trim() === ""
      ? ""
      : rawWarehouse.replace(/^['"]+|['"]+$/g, "");
  const channel = searchParams.get("Channel");

  //const pricelist = (searchParams.get("Pricelist") === null || searchParams.get("Pricelist") === '' ) ? "" : searchParams.get("Pricelist"); //#searchParams.get("Pricelist") || "";
  // const pricelist = (searchParams.get("Pricelist") === null || searchParams.get("Pricelist") == ' ' )
  // ? ""
  // : searchParams.get("Pricelist");
  const rawPricelist = searchParams.get("Pricelist");
  const pricelist =
    !rawPricelist || rawPricelist.trim() === ""
      ? ""
      : rawPricelist.replace(/^['"]+|['"]+$/g, "");
  const rawproductCode = searchParams.get("ProductCode");
  const productCode =
    !rawproductCode || rawproductCode.trim() === ""
      ? ""
      : rawproductCode.replace(/^['"]+|['"]+$/g, "");

  //const productCode = (searchParams.get("ProductCode") === null || searchParams.get("ProductCode") == '') ? "" : searchParams.get("ProductCode"); //searchParams.get("ProductCode") || "";
  const monthYear = dayjs(searchParams.get("monthYear"));
  const isFilterApplied = warehouse || channel || pricelist || productCode;
  const isEditMode =( (warehouse && channel) || (pricelist && productCode) || (warehouse && productCode));
  //console.log("logss ",isEditMode)
  const filters = isEditMode
    ? {
        Warehouse: warehouse,
        Channel: channel,
        Pricelist: pricelist,
        ProductCode: productCode,
        monthYear: monthYear,
      }
    : null;
  const { loading, data: rowData } = CurrentMonthRowData(
    type,
    {
      warehouse,
      channel,
      pricelist,
      productCode,
    },
    filters,
    currencyType
  );
  const [colDefs] = useState(currentMonthColDef);
  const {
    openModalWithAGValues,
    customOpenModal,
    setCustomOpenModal,
    mode,
    closeModal,
    editingValue,
    openModalWithAGValues02,
    alertModalOpen,
    setAlertModalOpen,
    setNewSchemeModalOpen,
    newSchemeModalOpen,
    lineDataClick,
    setSaveLoading,
  } = useModalContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeFilters, setActiveFilters] = useState();
  const [rowIndex, setRowIndex] = useState();
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const gridApiRef = useRef(null);
  // const [monthYear, setMonthYear] = useState(dayjs());
  const [editValue, setEditValue] = useState();
  const [dayTotalEditValue, setDayTotalEditValue] = useState("");
  const [monthtotaleditValue, setmonthtotaleditValue] = useState("");
  const [callValue, setCallValue] = useState(null);
  const [rowColumn, setRowColumn] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [baselineRateValue, setBaselineRateValue] = useState(0);
  const [schemeTypeData, setSchemeTypeData] = useState(false);
  const [loadingButton, setLoadingButton] = useState();
  const [updateLoading, setUpdateLoading] = useState(false);
  const [loadingRowType, setLoadingRowType] = useState(null);
  const [snackbarAlertOpen, setSnackbarAlertOpen] = useState(false);
  const [snackbarAlertMessage, setSnackbarAlertMessage] = useState("");
  const [SnackbarAlertSeverity, setSnackbarAlertSeverity] = useState("success");
  const [modalformData, modalsetFormData] = useState({
    schemeName: "",
    schemeStartDate: null,
    schemeEndDate: null,
    warehouse: [],
    channel: [],
    pricelist: [],
    productName: [],
    product: [],
    schemeType: "",
    rateImpact: "",
    quantityImpact: "",
    schemeImpactValue: "",
  });
  const [allLeafChildren, setAllLeafChildrens] = useState([]);

  const clearModalFormData = () => {
    modalsetFormData((prevData) => ({
      ...prevData,
      rateImpact: "",
      quantityImpact: "",
      schemeImpactValue: "",
    }));
  };

  //edit permission
  useEffect(() => {
    const fetchPermission = async () => {
      const permissions = await fetchEditPermissions();
      setIsButtonEnabled(permissions.Current_Month === 1);
    };

    fetchPermission();
  }, []);

  // const updateRowData = (data) => {
  //   if (data && data.length === 1 && isGroup!==true) {
  //     if (gridApiRef.current) {
  //       const rowNode = gridApiRef.current.getRowNode(rowIndex);
  //       if (rowNode) {
  //         rowNode.setData(roundData(formatUpdatedCurrentMonthData(data[0])));
  //         gridApiRef.current.refreshClientSideRowModel("aggregate");
  //       } else {
  //         console.error("Row node not found for ID:", rowIndex);
  //       }
  //     }
  //   } else if (data?.length > 1) {
  //     if (gridApiRef.current) {
  //       const rowNode = gridApiRef.current.getRowNode(rowIndex);
  //       if (rowNode) {
  //         data.map((d) => {
  //           rowNode.setData(roundData(formatUpdatedCurrentMonthData(d)));
  //         });
  //       } else {
  //         // console.error("Row node not found for ID:", rowIndex);
  //         data.forEach((d) => {
  //           const rowNode = allLeafChildren.find(
  //             (children) =>
  //               children.data.ProductCode === d.ProductCode &&
  //               children.data.Warehouse === d.Warehouse &&
  //               children.data.OutletType === d.OutletType &&
  //               children.data.Pricelist === d.Pricelist
  //           );
  //           if (rowNode) {
  //             rowNode.setData(roundData(formatUpdatedCurrentMonthData(d)));
  //           } else {
  //             console.error("Row node not found for ID:", rowIndex);
  //           }
  //         });
  //       }
  //       gridApiRef.current.refreshClientSideRowModel("aggregate");
  //     }
  //   }
  //   else if (data && data.length === 1 && isGroup === true) {
  //     data.forEach((d) => {
  //       const rowNode = allLeafChildren.find(
  //         (children) =>
  //           children.data.ProductCode === d.ProductCode &&
  //           children.data.Warehouse === d.Warehouse &&
  //           children.data.OutletType === d.OutletType &&
  //           children.data.Pricelist === d.Pricelist
  //       );
  //       if (rowNode) {
  //         rowNode.setData(roundData(formatUpdatedCurrentMonthData(d)));
  //       } else {
  //         console.error("Row node not found for ID:", rowIndex);
  //       }
  //     });
  //     gridApiRef.current.refreshClientSideRowModel("aggregate");

  //   }

  // };
const updateRowData = (updatedItems) => {
  if (!gridApiRef.current) return;

  updatedItems.forEach((item) => {
    // 1️⃣ Update normal rows via rowNode
    if (item.rowNodeId) {
      const rowNode = gridApiRef.current.getRowNode(item.rowNodeId);
        if (rowNode) {
        rowNode.setData(roundData(formatUpdatedCurrentMonthData(item)));
        } else {
        console.warn("Row node not found for ID:", item.rowNodeId);
        }
      }
    // 2️⃣ Update leaf children if provided
    else if (allLeafChildren?.length) {
      allLeafChildren.forEach((child) => {
        if (
          child.data.ProductCode === item.ProductCode &&
          child.data.Warehouse === item.Warehouse &&
          child.data.OutletType === item.OutletType &&
          child.data.Pricelist === item.Pricelist
        ) {
          child.setData(roundData(formatUpdatedCurrentMonthData(item)));
            }
          });
        }
    // 3️⃣ Update ROOT_NODE_ID / grand total
    else if (item.isRoot) {
      const rootNode = gridApiRef.current.getDisplayedRowAtIndex(0); // Grand Total is always first row
      if (rootNode) {
        const newAggData = { ...rootNode.aggData, ...item }; // Merge updated values
        Object.keys(newAggData).forEach((key) => {
          rootNode.setDataValue(key, newAggData[key]);
        });
      }
    }
  });

  // Refresh aggregates
      gridApiRef.current.refreshClientSideRowModel("aggregate");
  gridApiRef.current.redrawRows();
  };


  const handleGetFilters = () => {
    const filterModel = gridApiRef.current.getFilterModel();
    setActiveFilters(filterModel);
  };

  const handleSnackbarClose = () => {
    setSnackbarAlertOpen(false);
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
  };

  const onCellClicked = (event) => {
    // const date = new Date();
    // const today = date.getDate();
    setRowIndex(event.node.id);
    const fields = Array.from({ length: 31 }, (v, i) =>
      (i + new Date().getDate() + 2).toString()
    );

    // Check if the clicked row is a group row
    const isGroupRow = event.node.group;

    if (fields?.includes(event.colDef.field) && event.colDef.field) {
      openModalWithAGValues(
        event.data,
        event.colDef.field,
        event.data?.Warehouse,
        "",
        "",
        getDatesFromMonthYearAsia(monthYear)
      );
    }

    if (event.colDef.field === "M" && event.colDef.field && !isGroupRow) {
      openModalWithAGValues(
        event?.data,
        event.colDef.field,
        event?.data?.Warehouse,
        "",
        "",
        getDatesFromMonthYearAsia(monthYear)
      );
    }
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 120,
      width: 120,
      pinned: "left",
      filter: "agGroupColumnFilter",
      cellRendererParams: {
        totalValueGetter: (params) => {
          const isRootLevel = params.node.level === -1;
          if (isRootLevel) {
            return "Grand Total";
          }
          return `Sub Total (${params.value})`;
        },
        suppressCount: true,
      },
    };
  }, []);

    const onGridColumnsChanged = (event) => {
      const columnState = event?.api?.getColumnState();
      const colData = columnState
        ?.filter((col) => !col.rowGroup)
        .map((col) => ({ colId: col.colId, rowGroup: col.rowGroup }));
      if (gridApiRef) {
        const filterModel = event?.api?.getFilterModel();
        colData.map((col) => {
          delete filterModel[col?.colId]; // Remove filter for the hidden column
        });
        event?.api?.setFilterModel(filterModel);
      }
    };

  const sideBar = {
    toolPanels: [
        {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
        toolPanelParams: {
          suppressPivotMode: true,
          suppressPivots: true, //Hide column label
        },
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ],
    defaultToolPanel: "",
  };

  const handleOpenModal02 = () => {
    setIsModalOpen(true);
  };

  // const handleOpenModal = (rowData) => {
  //   console.log(editValue, "!editValue[0].Qty_Impact");
  //   if (!editValue[1].Qty_Impact) {
  //     setSchemeTypeData(rowData);
  //     setNewSchemeModalOpen(true);
  //   } else {
  //     // alert("You can't create new scheme for this product");
  //     setAlertModalOpen(true);
  //   }

  // };

  const handleOpenModal = (rowData) => {
    const correctionEntry = editValue.find(
      (entry) => entry.Request_Type === "Correction"
    );

    // if (correctionEntry && parseFloat(correctionEntry.Sales) > 0) {
    //   // If Correction Sales value exists, show alert modal
    //   setAlertModalOpen(true);
    //   setSchemeTypeData(rowData);
    // } else {
    //   // If no Correction Sales value, proceed with scheme setup
    //   setSchemeTypeData(rowData);
    //   setNewSchemeModalOpen(true);
    // }
    setSchemeTypeData(rowData);
    setNewSchemeModalOpen(true);
  };

  const onRowClicked = (event) => {
    const currentDate = dayjs();
    const currentDay = currentDate.date();
    const isPastMonth = monthYear.isBefore(dayjs(), "month");
    const columnState = gridApiRef.current.getColumnState();
    setAllLeafChildrens(event?.node?.allLeafChildren);
    const columnExists = (columnState, searchText) => {
      return columnState.some(
        (c) => c.colId && c.colId.toLowerCase().includes(searchText.toLowerCase())
      );
    };

    // Usage
    const productNameGroup = "ag-Grid-AutoColumn-Product_Name";
    const pricelistGroup = "ag-Grid-AutoColumn-Pricelist";
    const channelGroup = "ag-Grid-AutoColumn-OutletType";
    const warehouseGroup = "ag-Grid-AutoColumn-Warehouse";

    const hasProductName = columnExists(columnState, productNameGroup);
    const hasPricelist = columnExists(columnState, pricelistGroup);
    const hasChannel = columnExists(columnState, channelGroup);
    const hasWarehouse = columnExists(columnState, warehouseGroup);

    // console.log("hasProductName", hasProductName);
    // console.log("hasPricelist", hasPricelist);
    // console.log("hasChannel", hasChannel);
    // console.log("hasWarehouse", hasWarehouse);
    if (
      isPastMonth ||
      currentDay === event.colDef.field ||
      currentDay + 1 === event.colDef.field
    ) {
      console.log("Cannot edit data for past dates, today, or tomorrow.");
      return;
    }
    console.log("node index",event)
    setRowIndex(event.node.id);
    setRowColumn(event.colDef.field);
    const RowColumns = event?.source?.rowId;

    const clickedDate = event.colDef.field;
    setSelectedDate(clickedDate);
    let clickedRowDataProductCode02 = event?.node?.data;
    if (event.node.group === true && event.node.level === -1) {
      setIsGroup(true)
      const groupagg_rowdata = event.node.aggData;
      groupagg_rowdata["Warehouse"] = warehouse;
      groupagg_rowdata["OutletType"] = channel;
      groupagg_rowdata["Pricelist"] = pricelist??"";
      groupagg_rowdata["ProductCode"] = productCode??"";
      clickedRowDataProductCode02 = groupagg_rowdata;
    }

    if(event.node.group === true &&  event.node.level != -1){

      setIsGroup(true)
      const groupagg_rowdata = event.node.aggData;
      const getchildata = event?.node?.allLeafChildren[0]?.data;
      console.log("getchildata",getchildata.OutletType)
      // groupagg_rowdata["Warehouse"]    = warehouse   !== "" ? (hasWarehouse   ? getchildata.Warehouse   : warehouse)   : "";
      // groupagg_rowdata["OutletType"]      = channel     !== "" ? (hasChannel     ? getchildata.OutletType    : channel)     : "";
      // groupagg_rowdata["Pricelist"]    = pricelist   !== "" ? (hasPricelist   ? getchildata.Pricelist   : pricelist)   : "";
      // groupagg_rowdata["ProductCode"] = productCode !== "" ? (hasProductName ? getchildata.ProductCode  : productCode) : "";

      groupagg_rowdata["Warehouse"] =
        warehouse === ""
          ? (hasWarehouse ? getchildata.Warehouse : "")
          : (hasWarehouse ? getchildata.Warehouse : warehouse);

      groupagg_rowdata["OutletType"] =
        channel === ""
          ? (hasChannel ? getchildata.OutletType : "")
          : (hasChannel ? getchildata.OutletType : channel);

      groupagg_rowdata["Pricelist"] =
        pricelist === ""
          ? (hasPricelist ? getchildata.Pricelist : "")
          : (hasPricelist ? getchildata.Pricelist : pricelist);

      groupagg_rowdata["ProductCode"] =
        productCode === ""
          ? (hasProductName ? getchildata.ProductCode : "")
          : (hasProductName ? getchildata.ProductCode : productCode);
      groupagg_rowdata["Product_Name"] =
        productCode === ""
          ? (hasProductName ? getchildata.Product_Name : "")
          : (hasProductName ? getchildata.Product_Name : getchildata.Product_Name );


      const testing=productCode === ""
          ? (hasProductName ? getchildata.ProductCode : "")
          : (hasProductName ? getchildata.ProductCode : productCode);
      console.log("testing",testing)

      // groupagg_rowdata["Warehouse"] = warehouse;
      // groupagg_rowdata["OutletType"] = channel;
      // groupagg_rowdata["Pricelist"] = pricelist??"";
      // groupagg_rowdata["ProductCode"] = productCode??"";

      clickedRowDataProductCode02 = groupagg_rowdata;
    }
    //console.log("dhs",event?.node?.allLeafChildren["0"]?.data)

    var clickedDateObj = dayjs(
      new Date(monthYear.year(), monthYear.month(), clickedDate)
    );

    const dateAfter2Days = currentDate.add(1, "day");

    const isFieldDateValid = (field) => {
      return clickedDateObj >= dateAfter2Days;
    };
    setCallValue(clickedRowDataProductCode02);
    if (isFieldDateValid(clickedDate)) {
      openModalWithAGValues02(
        clickedRowDataProductCode02,
        getDatesFromMonthYearAsia(monthYear),
        setEditValue,
        RowColumns,
        clickedDate,
        "dayleveledit",
        type
      );

      setCustomOpenModal(true);
      setDayTotalEditValue(gridApiRef.current.getDisplayedRowAtIndex(0).aggData[event.colDef.field])
      setmonthtotaleditValue(gridApiRef.current.getDisplayedRowAtIndex(0).aggData["M"])
    } else {
      console.log("Invalid date or group row, action skipped.");
      setSnackbarAlertMessage("Invalid date or group row, action skipped.");
      setSnackbarAlertSeverity("info");
      setSnackbarAlertOpen(true);
    }
  };

  const handleCloseModal02 = () => {
    setNewSchemeModalOpen(false);
  };

  const alertModelClose = () => {
    setAlertModalOpen(false);
    setCustomOpenModal(true);
  };

  const handleCancelClick = (shouldOpenNewSchemeModal = false) => {
    // setLoading(true);
    setUpdateLoading(true);
    setSaveLoading(true);
    api
      .post("/deleteprocess", {
        body: lineDataClick,
        page: "dayleveledit",
      })
      .then((response) => {
        setSaveLoading(false);
        openModalWithAGValues02(
          callValue,
          getDatesFromMonthYearAsia(monthYear),
          setEditValue,
          rowColumn,
          selectedDate,
          "dayleveledit"
        );
        updateRowData(response.data.data_updated);
        setCustomOpenModal(true);
        // setLoading(false);
        console.error("correction canceled successfully:");
        setSnackbarAlertMessage("correction canceled successfully");
        setSnackbarAlertSeverity("success");
        setSnackbarAlertOpen(true);
      })
      .catch((error) => {
        console.error("Error canceling process:", error);
        setSnackbarAlertMessage("Failed to cancel correction");
        setSnackbarAlertSeverity("error");
        setSnackbarAlertOpen(true);
        setSaveLoading(false);
        setCustomOpenModal(true);
      })
      .finally(() => {
        setUpdateLoading(false);
        if (shouldOpenNewSchemeModal) {
          setCustomOpenModal(false);
          setNewSchemeModalOpen(true);
        }
      });
  };

  const handleCancelScheme = (rowType) => {
    setSaveLoading(true);
    setLoadingRowType(true);
    setLoadingButton(true);

    const requestBody = {
      ...lineDataClick,
      schemeType: rowType,
      page: "dayleveledit",
      type: type,
    };

    // setCustomOpenModal(false);
    api
      .post("/schemedeleteprocess", { body: requestBody })
      .then((response) => {
        setSaveLoading(false);
        openModalWithAGValues02(
          callValue,
          getDatesFromMonthYearAsia(monthYear),
          setEditValue,
          rowColumn,
          selectedDate,
          "dayleveledit"
        );
        updateRowData(response.data.data_updated);
        setCustomOpenModal(true);
        console.log(`Successfully canceled scheme of type: ${rowType}`);
        setSnackbarAlertMessage(
          `Successfully canceled scheme of type: ${rowType || ""}`
        );
        setSnackbarAlertSeverity("success");
        setSnackbarAlertOpen(true);
      })
      .catch((error) => {
        console.error("Error canceling process:", error);
        setSnackbarAlertMessage(`Failed to cancel scheme of: ${rowType || ""}`);
        setSnackbarAlertSeverity("error");
        setSnackbarAlertOpen(true);
        setSaveLoading(false);
        setCustomOpenModal(true);
      })
      .finally(() => {
        setLoadingRowType(false);
      });
  };

  const dayLevelDate = dayjs(
    new Date(monthYear.year(), monthYear.month(), selectedDate)
  );

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <LoadingSpinner />
          </div>
        </div>
      )}
      <div
        className="ag-table-container"
        style={{ marginLeft: open ? "240px" : "0px" }}
      >
        <div style={{ display: "flex", alignItems: "start", gap: "20px" }}>
          {/* {loading && <LoadingSpinner />} */}
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              justifyContent: "flex-end",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <Box sx={{ display: "none" }}>
              <BasicSelect
                value={currencyType}
                setValue={setCurrencyType}
                name="currenctType"
                options={[]}
              />
            </Box>
            <Box sx={{ display: "inline-flex" }}>
              <BasicSelect
                value={type}
                setValue={setType}
                name="Type"
                options={TYPES}
              />
            </Box>
            <Button
              variant="contained"
              disabled={!isButtonEnabled}
              onClick={handleOpenModal02}
              style={{
                minWidth: "150px",
                minHeight: "55px",
                flexGrow: 1,
                marginLeft: "8px",
                backgroundColor: !isButtonEnabled ? "#e0e0e0" : "#16a695",
                color: !isButtonEnabled ? "#9e9e9e" : "#fff",
                cursor: !isButtonEnabled ? "not-allowed" : "pointer",
                display: "none",
              }}
              color="primary"
              size="medium"
            >
              Add New Product
            </Button>

            <span style={{ display: "flex", gap: "20px" }}>
              <p
                style={{
                  fontSize: "16px",
                  margin: "0",
                }}
              >
                Warehouse: <b>{warehouse}</b>
              </p>
              <p
                style={{
                  fontSize: "16px",
                  margin: "0",
                }}
              >
                Channel: <b>{channel}</b>{" "}
              </p>
            </span>
          </div>
        </div>
        <div
          className="ag-theme-quartz"
          style={{
            width: "100%",
            height: "calc(100dvh - 190px)",
            fontSize: "12px",
          }}
        >
          <AgGridReact
            rowData={rowData}
            columnDefs={colDefs}
            pivotMode={true}
            sideBar={sideBar}
            onCellClicked={onRowClicked}
            autoGroupColumnDef={autoGroupColumnDef}
            grandTotalRow={"top"}
            onGridReady={onGridReady}
            onFilterChanged={handleGetFilters}
            suppressAggFuncInHeader={true}
            groupDisplayType="multipleColumns"
            showOpenedGroup={true}
            groupHideOpenParents={true}
            groupDefaultExpanded={-1}
            groupSuppressAutoColumn={true}
            alwaysShowHorizontalScroll={true}
            onGridColumnsChanged={onGridColumnsChanged}
          />
        </div>
        {/* <ModalComponent
        activeFilters={activeFilters}
        updateRowData={updateRowData}
      /> */}

        {!monthYear.isBefore(dayjs(), "month") && (
          <EditModal
            open={customOpenModal}
            setCustomOpenModal={setCustomOpenModal}
            mode={mode}
            handleClose={closeModal}
            data={editingValue}
            editValue={editValue}
            callValue={callValue}
            monthYear={monthYear}
            updateRowData={updateRowData}
            rowColumn={rowColumn}
            setCallValue={setCallValue}
            // columns={columns}
            modalName={"Day Level Edit"}
            dayLevelButton={false}
            page={"dayleveledit"}
            handleOpenModal={handleOpenModal}
            closeModal={closeModal}
            pricelist02={pricelist}
            handleCancelScheme={handleCancelScheme}
            handleCancelClick={handleCancelClick}
            updateLoading={updateLoading}
            setUpdateLoading={setUpdateLoading}
            loadingRowType={loadingRowType}
            setLoadingRowType={setLoadingRowType}
            clearModalFormData={clearModalFormData}
            setSnackbarAlertMessage={setSnackbarAlertMessage}
            setSnackbarAlertSeverity={setSnackbarAlertSeverity}
            setSnackbarAlertOpen={setSnackbarAlertOpen}
            modalsides={"Day Outlook"}
            dayTotalEditValue={dayTotalEditValue}
            monthtotaleditValue={monthtotaleditValue}
            type={type}
          />
        )}

        <AddNewScheme
          newSchemeModalOpen={newSchemeModalOpen}
          handleCloseModal02={handleCloseModal02}
          callValue={callValue}
          rowColumn={rowColumn}
          editValue={editValue}
          setEditValue={setEditValue}
          schemeTypeData={schemeTypeData}
          setCallValue={setCallValue}
          setCustomOpenModal={setCustomOpenModal}
          monthYear={monthYear}
          handleClose={closeModal}
          page={"dayleveledit"}
          updateRowData={updateRowData}
          selectedDate={selectedDate}
          modalformData={modalformData}
          modalsetFormData={modalsetFormData}
          dayLevelDate={dayLevelDate}
        />

        <AddNewProductModal
          isModalOpen={isModalOpen}
          shouldDisableDate={true}
          setIsModalOpen={setIsModalOpen}
        />

        <AlertModal
          alertModalOpen={alertModalOpen}
          // handleClose={closeAlertModal}
          alertModelClose={alertModelClose}
          handleCancelScheme={handleCancelScheme}
          handleCancelClick={handleCancelClick}
          message={
            "You cannot create or modify the scheme for this product due to an existing correction value. To proceed, please delete the correction value by clicking 'Yes'."
          }
        />

        <Snackbar
          open={snackbarAlertOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={SnackbarAlertSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarAlertMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default CurrentMonth;
